import { render, staticRenderFns } from "./canshu.vue?vue&type=template&id=b319cc26"
import script from "./canshu.vue?vue&type=script&lang=js"
export * from "./canshu.vue?vue&type=script&lang=js"
import style0 from "./canshu.vue?vue&type=style&index=0&id=b319cc26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports